import { createReducer, on } from '@ngrx/store';
import { Entities, Permission, Role, User } from '../../../shared/models';
import { Applicant } from '../../../shared/models/Applicant';
import { AuthenticationConstants } from '../../constants';
import * as authenticationActions from '../actions/authentication.action';

export interface State {
  isApplicantLoggedIn: boolean;
  applicant: Applicant;
  applicantToken: string;
  applicantExpiresAt: Date;
  isUserLoggedIn: boolean;
  user: User;
  userToken: string;
  userExpiresAt: Date;
}

const initialState: State = {
  isApplicantLoggedIn: null,
  applicant: null,
  applicantToken: null,
  applicantExpiresAt: null,
  isUserLoggedIn: null,
  user: null,
  userToken: null,
  userExpiresAt: null,
};

export const reducer = createReducer(
  initialState,
  on(authenticationActions.LoginApplicant, (state, action) => ({
    ...state,
    isApplicantLoggedIn: true,
    applicant: action.data.applicant,
    applicantToken: action.data.token,
    applicantExpiresAt: new Date(action.data.expiresAt),
    isUserLoggedIn: null,
    user: null,
    userToken: null,
    userExpiresAt: null,
  })),
  on(authenticationActions.LoggedInSuccessApplicant, (state, action) => ({
    ...state,
    isApplicantLoggedIn: true,
    applicant: action.data.applicant,
    applicantToken: action.data.token,
    applicantExpiresAt: new Date(action.data.expiresAt),
    isUserLoggedIn: null,
    user: null,
    userToken: null,
    userExpiresAt: null,
  })),
  on(authenticationActions.LogoutApplicantSuccess, (state, action) => {

    localStorage.removeItem(AuthenticationConstants.APPLICANT_TOKEN);
    localStorage.removeItem(AuthenticationConstants.APPLICANT_EXPIRES_AT);

    return {
      ...state,
      isApplicantLoggedIn: false,
      applicant: null,
      isUserLoggedIn: null,
      user: null,
      applicantToken: null,
      applicantExpiresAt: null,
      userToken: null,
      userExpiresAt: null,
    };
  }),
  on(authenticationActions.LoginUser, (state, action) => ({
    ...state,
    isApplicantLoggedIn: null,
    applicant: null,
    applicantToken: null,
    applicantExpiresAt: null,
    isUserLoggedIn: true,
    user: action.data.user,
    userToken: action.data.token,
    userExpiresAt: new Date(action.data.expiresAt)
  })),
  on(authenticationActions.LoggedInSuccessUser, (state, action) => ({
    ...state,
    isApplicantLoggedIn: null,
    applicant: null,
    applicantToken: null,
    applicantExpiresAt: null,
    isUserLoggedIn: true,
    user: action.data.user,
    userToken: action.data.token,
    userExpiresAt: new Date(action.data.expiresAt)
  })),
  on(authenticationActions.LogoutUserSuccess, (state, action) => {

    localStorage.removeItem(AuthenticationConstants.USER_TOKEN);
    localStorage.removeItem(AuthenticationConstants.USER_EXPIRES_AT);

    return {
      ...state,
      isApplicantLoggedIn: null,
      applicant: null,
      isUserLoggedIn: null,
      user: null,
      applicantToken: null,
      applicantExpiresAt: null,
      userToken: null,
      userExpiresAt: null,
    };

  }),
);
